import { Body1, Body1Strong, Body2, Button, Field, Spinner, Subtitle1, Title1, makeStyles, mergeClasses, shorthands } from '@fluentui/react-components';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Payment32Regular,
  ArrowLeftFilled
} from "@fluentui/react-icons";

import { useMsal, useAccount } from '@azure/msal-react';
import { silentRequest } from '../../authConfig';
import axios from 'axios';
import { useLocation, useHistory } from 'react-router-dom';

const homeStyles = {
    border: 0,
    margin: 0,
    width: '100%',
    minWidth: 'calc(100vw - 310px)',
    background: '#FAF9F8',
    position: 'relative',
  };

  const useStyles = makeStyles({
    root: {
        display: "flex",
        // backgroundColor: "#fff",
        flexDirection: "column",
        width: "900px",
    },
    detail: {
        // ...shorthands.border("2px", "solid", "#ccc"),
        // ...shorthands.overflow("hidden"),
        display: "flex",
        // height: "480px",
        // backgroundColor: "#fff",
        ...shorthands.gap("20px"),
        justifyContent: "center"
    },
    userDetail: {
        // ...shorthands.border("2px", "solid", "#ccc"),
        ...shorthands.overflow("hidden"),
        display: "flex",
        height: "400px",
        width: "605px",
        ...shorthands.padding("20px"),
        ...shorthands.borderRadius("10px"),
        boxShadow: "rgba(0, 0, 0, 0.133) 0px 1.6px 3.6px 0px, rgba(0, 0, 0, 0.11) 0px 0.3px 0.9px 0px",
    },
    paymentDetail: {
        // ...shorthands.border("2px", "solid", "#ccc"),
        ...shorthands.overflow("hidden"),
        display: "flex",
        height: "400px",
        width: "319px",
        ...shorthands.padding("20px"),
        ...shorthands.borderRadius("10px"),
        boxShadow: "rgba(0, 0, 0, 0.133) 0px 1.6px 3.6px 0px, rgba(0, 0, 0, 0.11) 0px 0.3px 0.9px 0px",
    },
    flex: {
      display: "flex", 
      justifyContent: "end", 
      alignItems: "center",
      ...shorthands.gap("20px"),
    },
    flexLeft: {
      display: "flex", 
      justifyContent: "start", 
      alignItems: "center",
      ...shorthands.gap("5px"),
    },
    contentSpacing: {
      display: "flex", 
      alignItems: "center",
      ...shorthands.gap("5px"),
    },
    stack: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'nowrap',
      width: 'auto',
      height: 'auto',
      boxSizing: 'border-box',
      '> *': {
        textOverflow: 'ellipsis',
      },
      '> :not(:first-child)': {
        marginTop: '0px',
      },
      '> *:not(.ms-StackItem)': {
        flexShrink: 1,
      },
    },
    vertical: {
      display: 'flex',
      flexDirection: 'column',
    },
    verticalCenter: {
      display: 'flex',
      alignItems: "center"
    },
    fullWidth: {
      width: "100%"
    },
    spaceBetween: {
      justifyContent: "space-between"
    },
    columnGap: {
      ...shorthands.gap("0px", "10px"),
    },
    horizontalSpaceBetween: {
      display: "flex",
      justifyContent: "space-between"
    },
  });

//   const slideDown = keyframes`
//   from {
//     transform: translateY(-100%);
//   }
//   to {
//     transform: translateY(0);
//   }
// `;

// const AnimatedRow = styled.tr`
//   border: 1px solid black;
//   padding: 8px;
//   animation: ${slideDown} 0.5s ease;
// `;

function makeDecimalNumber(num) {
  return num.toLocaleString(undefined, {
     maximumFractionDigits: 2,
     minimumFractionDigits: 2,
   })
 }

const API_URL = process.env.REACT_APP_API_URL;

const PackageBillingDetail = () => {
  const history = useHistory();
  const location = useLocation();
    const styles = useStyles();

    const { t, i18n } = useTranslation();

    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});

    const [buyingPackage, setBuyingPackage] = useState(null)

    const [currentMainPackage, setCurrentMainPackage] = useState(null)

    const companyId = sessionStorage.getItem('companyId') || '';

    const [manual, setManual] = useState(true)

    const [loading, setLoading] = useState(true)

    const [backUrl, setBackUrl] = useState('/packages');

    const [getCurrentMainPackageSuccess, setGetCurrentMainPackageSuccess] = useState(false)
    const [getCompanyDetailSuccess, setGetCompanyDetailSuccess] = useState(false)

    function handleGoback(e) {
      history.push({
        pathname: backUrl,
        state: {},
      });
    }

    useEffect(() => {
      if (getCompanyDetailSuccess && getCurrentMainPackageSuccess) {
        setLoading(false)
      }
    }, [getCompanyDetailSuccess, getCurrentMainPackageSuccess])
    

    function getCurrentMainPackage() {
      instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then(async (tokenResponse) => {
        const responseCurrentPackage = await axios.get(`${API_URL}/packages/current`, {
                                                        headers: {
                                                          Authorization: 'Bearer ' + tokenResponse.accessToken,
                                                          'cid': companyId,
                                                        },
                                                      })

        setCurrentMainPackage(responseCurrentPackage.data.status !== 'expired' ? responseCurrentPackage.data : null)
      
        setGetCurrentMainPackageSuccess(true)
      }).catch((error) => {
        //Acquire token silent failure, and send an interactive request
        console.log("getPackageAndAccountDetail error", error);
        // instance.acquireTokenRedirect(silentRequest);
      });
    }

    async function fetchCompanyData() {
      console.log('userEffect retrieve company and accounts data!');
  
      const urlPath = window.location.pathname;
      console.log('Body urlPath: ', urlPath);
  
      instance
        .acquireTokenSilent({ ...silentRequest, account: account })
        .then((tokenResponse) => {
          console.log('tokenResponse: ', tokenResponse);
  
          axios
            .get(API_URL + '/etax/companies', {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
              },
            })
            .then(
              (response) => {
                console.log(response);
  
                if (response.data.length === 0) {
                } else {
  
                  let _cid = ""
                  if (sessionStorage.getItem("companyId") && response.data.find(_company => _company.id === sessionStorage.getItem("companyId"))) {
                    // sessionStorage.setItem("companyId", response.data[0].id);
                    _cid = sessionStorage.getItem("companyId")
                  } else {
                    sessionStorage.setItem("companyId", response.data[0].id);
  
                    _cid = response.data[0].id
                  }
  
                  axios
                      // .get(API_URL + '/companies-details/' + response.data[0].id, {
                      .get(API_URL + '/companies-details', {
                          headers: {
                              Authorization: 'Bearer ' + tokenResponse.accessToken,
                              'cid': _cid
                          },
                      })
                      .then((companiesDetailsResponse) => {
                          console.log('companiesDetailsResponse: ', companiesDetailsResponse);
                          if (companiesDetailsResponse.data) {
                            if (companiesDetailsResponse.data.billings === undefined || companiesDetailsResponse.data.billings.manual === undefined || companiesDetailsResponse.data.billings.manual) {
                              setManual(true)
                              setLoading(false)

                              // history.push({
                              //   pathname: '/etax/documents/all',
                              //   state: {},
                              // });
                            } else {
                              setManual(false)
                              setGetCompanyDetailSuccess(true)
                            }
                          }
  
                      })
                      .catch((error) => {
                          console.log(error);
                      })
                   }
              },
              (error) => {
                console.log(error);
              }
            );
        })
        .catch((error) => {
          //Acquire token silent failure, and send an interactive request
          console.log(error);
          instance.acquireTokenRedirect(silentRequest);
        });
    }
  
    async function initLocationProps(_location) {
      const locationProps = _location.state

      if (locationProps) {
        setBuyingPackage(locationProps.package)
        setBackUrl(locationProps.backUrl)
      } else {
        handleGoback()
      }
      
    }

    useEffect(() => {
      fetchCompanyData()
      initLocationProps(location)
      getCurrentMainPackage()

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function handleGotoPaymentChannel() {
      history.push({
        pathname: '/payments/channels',
        state: {
          packageId: buyingPackage.packageId,
          total: makeDecimalNumber(buyingPackage.price - ((currentMainPackage.price / currentMainPackage.monthsLimit) * (currentMainPackage.monthRemaining))),
          backUrl: '/packages',
        },
      });
    }

    function getCurrentPackageName(currentMainPackage, language) {
      if (currentMainPackage) {
        if (language === "th") {
          return currentMainPackage.descriptionTH
        } else {
          return currentMainPackage.descriptionEN
        }
      } else {
        return "-"
      }
    }

    return <div style={homeStyles}>
      {manual ? (
        <div style={{ display: "flex", justifyContent: "center", marginTop: 21}}>
          {loading ? (
            <div style={{ display: "flex", alignContent: "center", height: "100%", width: "100%", justifyContent: "center"}}>
              <Spinner labelPosition="below" label={t(`packageBillingDetail.loading`)} />
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column"}}>
              <div style={{ marginBottom: 21}}>
                <Subtitle1>{t(`packageBillingDetail.thisPageCannotReach`)}</Subtitle1>
  
              </div>
              <div style={{ display: "flex", justifyContent: "center"}}>
                <Button 
                  appearance='primary' 
                  onClick={() =>  
                    history.push({
                      pathname: '/etax/documents/all',
                      state: {},
                    })}
                >
                  {t(`packageBillingDetail.homepage`)}
                </Button>
                
              </div>
            </div>
          )}
        </div>
      ) : (
        <>
          <div style={{ display: "flex", justifyContent: "center"}}>
              <div className={styles.root}>
                  <Title1 as='h1'>
                    <div style={{ display: "flex", flexDirection: "row"}}>
                      <div className={styles.verticalCenter} style={{ paddingRight: 5}}>
                        <Payment32Regular />
                      </div>
                      <div className={styles.verticalCenter}>
                        <div>
                          {t(`packageBillingDetail.paymentDetailHeader`)}
                        </div>
                      </div>
                    </div>
                  </Title1>
                  <div className={styles.detail}>
                    {loading ? (
                      <div style={{ display: "flex", alignContent: "center", height: "100%", width: "100%", justifyContent: "center"}}>
                          <Spinner labelPosition="below" label={t(`packageBillingDetail.loading`)} />
                      </div>
                    ) : (
                      <>
                        <div className={styles.userDetail}>
                          <div className={mergeClasses(styles.vertical, styles.columnGap)}>
                            <div onClick={handleGoback} style={{ display: "flex", flexDirection: "row"}}>
                              <div className={styles.verticalCenter} style={{ paddingRight: 5}}>
                                <ArrowLeftFilled />
                              </div>
                              <div className={styles.verticalCenter}>
                                <Body1>{t(`paymentHistory.back`)}</Body1>
                              </div>
                            </div>
                            <Subtitle1 style={{ backgroundColor: "rgb(238, 238, 238)"}}>{t(`packageBillingDetail.package`)}</Subtitle1>
                            
                            
                            <div style={{ width: 520 }}>
                              <div className={mergeClasses(styles.fullWidth, styles.spaceBetween, styles.horizontalSpaceBetween)}>
                                <div style={{ width: 300}}>
                                  <Body2>{getCurrentPackageName(buyingPackage, i18n.language)}</Body2>
                                </div>
                                <div style={{ display: "flex", flexDirection: 'row', gap: 20}}>
                                  <div>
                                    <Body2>{makeDecimalNumber(buyingPackage.price) || 0}</Body2>
                                  </div>
                                  <div>
                                    <Body2>
                                      {t(`packageBillingDetail.baht`)}
                                    </Body2>
                                  </div>
                                </div>
                              </div>
                              <div className={mergeClasses(styles.fullWidth, styles.spaceBetween, styles.horizontalSpaceBetween)} style={{ color: "#A4262C"}}>
                                <div style={{ width: 350}}>
                                  <Body2>
                                    {t(`packageBillingDetail.discountMessage1`)} {currentMainPackage.monthRemaining}{t(`packageBillingDetail.discountMessage2`)}

                                  </Body2>
                                </div>
                                <div style={{ display: "flex", flexDirection: 'row', gap: 20}}>
                                  <div>
                                    <Body2>
                                      {makeDecimalNumber((currentMainPackage.price / currentMainPackage.monthsLimit) * (currentMainPackage.monthRemaining)) || 0}
                                      
                                    </Body2>
                                  </div>
                                  <div>
                                    <Body2>
                                      {t(`packageBillingDetail.baht`)}
                                    </Body2>
                                  </div>
                                </div>
                              </div>
                                
                            </div>
                          </div>
                        </div>
                        <div className={styles.paymentDetail}>
                          <div className={mergeClasses(styles.vertical, styles.fullWidth, styles.spaceBetween)}>
                            <div className={mergeClasses(styles.vertical, styles.columnGap)}>
                              <Subtitle1 style={{ backgroundColor: "rgb(238, 238, 238)"}}>{t(`packageBillingDetail.paymentInformation`)}</Subtitle1>
                              <Field label={<Body1>{t(`packageBillingDetail.amountDue`)}</Body1>}>
                                <div style={{ border: "1px solid #0f6cbd", borderRadius: 10, height: 30, display: "flex", flexDirection: "row", justifyContent: "space-between", padding: 10, alignItems: "center"}}>
                                  <Title1 style={{ color: "#0f6cbd"}}>{makeDecimalNumber(buyingPackage.price - ((currentMainPackage.price / currentMainPackage.monthsLimit) * (currentMainPackage.monthRemaining)))}</Title1>
                                  <Body1Strong>{t(`packageBillingDetail.baht`)}</Body1Strong>
                                </div>

                              </Field>
                            </div>
                            <Button appearance="primary" size='large' className={styles.fullWidth} onClick={handleGotoPaymentChannel}>
                              {t(`packageBillingDetail.pay`)}
                            </Button>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
              </div>

          </div>
        </>
      )}
    </div>
};

export default PackageBillingDetail;